import React, { useEffect } from "react";
import { useIntl } from 'react-intl';

// Components
import { Form, Pill } from 'Components';
import { Grid } from '@mui/material';
import Slider from 'Components/Slider';

import { useRealtimeUnits } from 'Core/hooks';
import { unitHasVidFleetCamera } from 'Modules/alerts/common/helpers/alertCommon';


export const StoppedReporting = (props) => {

    const { value, onChange, formRef } = props
    const { messages } = useIntl()
    // Re-render when the manufacturer fields arrive.
    const units = useRealtimeUnits({
        trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags', 'manufacturerName', 'linkedUnit', 'videoDevices']
    });
    const unitsCamera = units?.find(unitHasVidFleetCamera)


    useEffect(() => {
        if (value.triggerDuration == undefined) {
            onChange({
                ...value,
                triggerDuration: {
                    duration: 'Hours',
                    value: 1,
                }
            })
        }

        if (!value?.cameraTriggerDuration?.duration && unitsCamera) {
            onChange({
                ...value,
                cameraTriggerDuration: {
                    duration: 'Hours',
                    value: 8
                },
            })
        }
    }, [value, unitsCamera])

    const maxSliderValue = {
        Minutes: 59,
        Hours: 23,
        Days: 30,
    };

    const minSliderValue = {
        Minutes: 25,
        Hours: 1,
        Days: 1,
    };

    const maxSliderCameraValue = {
        Hours: 23,
        Days: 30,
    };

    const minSliderCameraValue = {
        Hours: 5,
        Days: 1,
    };

    const durationAbbreviation = {
        Minutes: messages['mins'],
        Hours: `${messages['Hour']}${value?.triggerDuration?.value > 1 ? 's' : ''}`,
        Days: `${messages['Day']}${value?.triggerDuration?.value > 1 ? 's' : ''}`,
    }

    const durationAbbreviationCamera = {
        Hours: `${messages['Hours']}`,
        Days: `${messages['Day']}${value?.cameraTriggerDuration?.value > 1 ? 's' : ''}`,
    }

    return (
        <Form ref={formRef} >
            <Grid container justifyContent={'center'} direction={'column'} style={{ paddingTop: 10 }}>
                <label className="input-normal-label">
                    {messages['alertsNewAlert_Parameters']}
                    <span className="text-danger"> *</span>
                </label>
                {units && units?.find(c => c?.type?.toUpperCase() != 'VIDFLEET' && c?.type?.toUpperCase() != 'SMARTWITNESS') &&
                    <div>
                        <label className="input-normal-label" style={{ marginTop: 10 }}>{messages['alersTabView_forGps']}</label>
                        <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                            <Grid item sm={4}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Minutes", name: messages["alertsNewAlert_minutesLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Minutes"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { duration: "Minutes", value: minSliderValue["Minutes"] } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                            <Grid item sm={4}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Hours", name: messages["alertsNewAlert_hoursLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Hours"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { duration: "Hours", value: minSliderValue["Hours"] } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                            <Grid item sm={4}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Days", name: messages["alertsNewAlert_daysLabel"] }}
                                    outlined={value.triggerDuration?.duration !== "Days"}
                                    onClick={(entity) => {
                                        onChange({ ...value, triggerDuration: { duration: "Days", value: minSliderValue["Days"] } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                        </Grid>
                        <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                            <label className="input-normal-label">{messages['alertsNewAlert_Over']}</label>
                            <Slider
                                min={minSliderValue[value.triggerDuration?.duration]}
                                max={maxSliderValue[value.triggerDuration?.duration]}
                                value={value.triggerDuration?.value}
                                onChange={(event) => {
                                    onChange({
                                        ...value,
                                        triggerDuration: {
                                            ...value.triggerDuration,
                                            value: event
                                        }
                                    });
                                }}
                                sliderOneColor={false}
                                showValue
                                valueLabelDisplay={'off'}
                                measure={durationAbbreviation[value.triggerDuration?.duration]}
                            />
                        </div>
                    </div>
                }

                {
                    unitsCamera &&

                    <div style={{ width: '100%', marginTop: 10, marginBottom: 30 }}>
                        <label className="input-normal-label">{messages['alersTabView_forCameras']}</label>
                        <Grid container direction="row" alignItems={'center'} spacing={1} color="primary" aria-label="outlined primary button group">
                            <Grid item sm={4}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Hours", name: messages["alertsNewAlert_hoursLabel"] }}
                                    outlined={value.cameraTriggerDuration?.duration !== "Hours"}
                                    onClick={(entity) => {
                                        onChange({ ...value, cameraTriggerDuration: { duration: "Hours", value: minSliderCameraValue["Hours"] } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                            <Grid item sm={4}>
                                <Pill
                                    textField={'name'}
                                    item={{ id: "Days", name: messages["alertsNewAlert_daysLabel"] }}
                                    outlined={value.cameraTriggerDuration?.duration !== "Days"}
                                    onClick={(entity) => {
                                        onChange({ ...value, cameraTriggerDuration: { duration: "Days", value: minSliderCameraValue["Days"] } })
                                    }}
                                    style={{ border: '0', margin: '2px 0', width: '100%' }}
                                    label="pill-label-text"
                                    colorField="default"
                                    colorSelection="005bf8"
                                />
                            </Grid>
                        </Grid>
                        <label className="input-normal-label">{messages['alertsNewAlert_Over']}</label>
                        <Slider
                            min={minSliderCameraValue[value.cameraTriggerDuration?.duration]}
                            max={maxSliderCameraValue[value.cameraTriggerDuration?.duration]}
                            value={value.cameraTriggerDuration?.value}
                            onChange={(event) => {
                                onChange({
                                    ...value,
                                    cameraTriggerDuration: {
                                        ...value.cameraTriggerDuration,
                                        value: event
                                    }
                                });
                            }}
                            sliderOneColor={false}
                            showValue
                            valueLabelDisplay={'off'}
                            measure={durationAbbreviationCamera[value.cameraTriggerDuration?.duration]}
                        />
                    </div>
                }
            </Grid>
        </Form>
    );
}
